<div class="product-content-image">
    <div class="d-flex justify-content-end width-100">
        <span class="cursor-pointer" matDialogClose>
            <svg xmlns="http://www.w3.org/2000/svg" width="15.6" height="15.598" viewBox="0 0 15.6 15.598">
                <path
                    d="M23.137,8.2a1.13,1.13,0,0,0-1.6,0l-5.866,5.866L9.8,8.2A1.131,1.131,0,0,0,8.2,9.8l5.866,5.866L8.2,21.537a1.131,1.131,0,0,0,1.6,1.6l5.863-5.863,5.866,5.866a1.131,1.131,0,1,0,1.6-1.6l-5.87-5.87L23.137,9.8A1.135,1.135,0,0,0,23.137,8.2Z"
                    transform="translate(-7.873 -7.872)" />
            </svg>
        </span>
    </div>
    <mat-dialog-content>
        <img [src]="image" alt="image">
    </mat-dialog-content>
</div>
